<template>
  <section :loading="true" class="indexPage posifix">
  </section>
</template>

<script>
import {
  getToken,
} from '@qx/utils/auth';
import {
  getCarList,
  chooseCar,
} from 'api/user';
import DEFAULT_HOME_PATH from '@/router/defaultHome';

const normalizeTenantItems = (res) => {
  if (Array.isArray(res)) {
    return res;
  }
  if (!res) {
    return [];
  }
  if (Array.isArray(res.items)) {
    return res.items;
  }
  if (Array.isArray(res.data)) {
    return res.data;
  }
  if (res.data && Array.isArray(res.data.items)) {
    return res.data.items;
  }
  if (res.content && Array.isArray(res.content.items)) {
    return res.content.items;
  }
  if (res.result && Array.isArray(res.result.items)) {
    return res.result.items;
  }
  return [];
};

export default {
  data () {
    return {
      companyList: [],
    };
  },
  methods: {
    async handleChoose (item) {
      const res = await chooseCar(item);
      if (!res.failed) {
        this.$router.push(DEFAULT_HOME_PATH);
      }
    },
  },
  async created () {
    if (!getToken()) {
      this.$router.replace('/login');
      return;
    }
    const res = await getCarList();
    const items = normalizeTenantItems(res);
    if (res && !res.failed && items.length === 1) {
      this.companyList = items.map((item) => ({
        tenantName: item.name,
        tenantId: item.tenantId,
        tenantCode: item.tenantCode,
        referer: DEFAULT_HOME_PATH,
      }));
      this.handleChoose(this.companyList[0]);
    } else if (res && !res.failed) {
      this.$router.replace('/home');
    }
  },
};
</script>

<style scoped lang="scss">
.indexPage{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
